import { Link } from 'react-router-dom'

import styles from './Breadcrumb.module.css'

export interface BreadcrumbProps {
  parent: string
  parentTo: string
  current: string
}

export function Breadcrumb({ parent, parentTo, current }: BreadcrumbProps) {
  return <nav className={styles.breadcrumb} aria-label="面包屑"><Link className={styles.link} to={parentTo}>{parent}</Link><span className={styles.separator}>/</span><span>{current}</span></nav>
}
